import React, { useState, useEffect } from "react";
import {} from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import { Url } from "../config/config";
import Modal from "react-bootstrap/Modal";
import useButtonLoader from "../hooks/useButtonLoader";
import useFullPageLoader from "../hooks/useFullPageLoader";

export default function Banner() {
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const [inputField, setInputField] = useState({
    id: "",
    clientName: "",
    banner: "",
    status: "1",
    preview: "",
    bannerUrl: "",
  });

  const [errorField, setErrorField] = useState({
    clientName: "",
    banner: "",
  });

  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Submit",
    "Please wait..."
  );

  //handele delete
  const [DeleteModal, setDeleteModal] = useState(false);
  const handelDeleteShow = (id) => {
    //console.log(id);
    setDeleteModal(true);
    setInputField({ ...inputField, id: id });
  };
  const handelDeleteClose = () => {
    setDeleteModal(false);
  };

  const handelDelete = async () => {
    try {
      const res = await axios({
        url: `${Url}/corporateClient?clientId=${inputField.id}`,
        method: "DELETE",
        data: {
          clientId: inputField.id,
        },
      });
      if (res.data.status === 200) {
        handelDeleteClose();
        toast.success(res.data.message);
        bannerList(activePage);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //***********Block UnBlock*************** */
  const [BlockModal, setBlockModal] = useState(false);
  const handelBlockShow = () => {
    setBlockModal(true);
  };

  const handelBlockClose = () => {
    setBlockModal(false);
  };
  const handleChecked = (e, id) => {
    handelBlockShow();
    setInputField({
      ...inputField,
      status: e.target.checked,
      id: id,
    });
  };

  const handelUpdateStatus = async () => {
    try {
      const res = await axios({
        url: `${Url}/corporateClient/status`,
        method: "POST",
        data: {
          clientId: inputField.id,
          status: inputField.status,
        },
      });
      console.log(res.data.status);
      if (res.data.status === 200) {
        handelBlockClose();
        toast.success(res.data.message);
        bannerList(activePage);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //***************Add Banner *********** */
  const [AddModal, setAddModal] = useState(false);
  const handelAddModalShow = () => {
    setInputField("");
    setErrorField("");
    setAddModal(true);
  };

  const handelAddModalClose = () => {
    setAddModal(false);
  };

  //*************Input Onchange***** */
  const handelInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputField({
      ...inputField,
      [name]: value,
    });
  };

  //**************Handel Image ********** */
  const handelImageOnchange = (e) => {
    setInputField({
      ...inputField,
      banner: e.target.files[0],
      preview: URL.createObjectURL(e.target.files[0]),
    });
  };

  //*************Handel Validation************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!inputField.clientName) {
      errorField["clientName"] = "Banner name field is required";
      formIsValid = false;
    }

    if (!inputField.banner) {
      errorField["banner"] = "Banner image field is required";
      formIsValid = false;
    }
    setErrorField(errorField);
    return formIsValid;
  };

  //*************Handel Submit*************** */
  const handelSubmit = async () => {
    try {
      setSubmitLoading(true);
      if (handleValidation()) {
        let res = await axios({
          url: `${Url}/corporateClient`,
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          data: {
            clientName: inputField.clientName,
            banner: inputField.banner,
          },
        });
        setSubmitLoading(false);
        if (res.data.status === 200) {
          handelAddModalClose();
          setInputField("");
          setErrorField("");
          bannerList(activePage);
          toast.success(res.data.message);
        } else if (res.data.status === 419) {
          toast.error(res.data.message);
        } else {
          toast.error("Something went to wrong");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  //*************Handel Edit *************** */
  const [EditModal, setEditModal] = useState(false);
  const handelEditModalClose = () => {
    setEditModal(false);
  };
  const handelEditModalShow = (data) => {
    setEditModal(true);
    setInputField({
      ...inputField,
      id: data._id,
      clientName: data.clientName,
      bannerUrl: data.banner,
    });
  };
  const handelEditSubmit = async () => {
    try {
      console.log("id", inputField.banner);
      //  return false;
      setSubmitLoading(true);
      const res = await axios({
        url: `${Url}/corporateClient`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
        data: {
          clientId: inputField.id,
          clientName: inputField.clientName,
          banner: inputField.banner,
        },
      });
      setSubmitLoading(false);
      // console.log(res);
      if (res.data.status === 200) {
        handelEditModalClose();
        bannerList(activePage);
        toast.success(res.data.message);
      } else if (res.data.status === 419) {
        toast.error(res.data.message);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const bannerList = async (page = 1, query = "") => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/corporateClient?page=${page}&search=${query}`,
        method: "GET",
        headers: {
          //Authorization: "Bearer " + accessToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      hideLoader();

      if (res.data.status === 200) {
        console.log(res.data.data.clientListing);
        setRecord(res.data.data.clientListing);
        setTotal(res.data.data.total);
      }
    } catch (err) {
      console.log(err);
    }
    // console.log(res.data.result);
  };

  useEffect(() => {
    bannerList(activePage);
  }, []);

  //*********Handel Search************** */
  const handelSearch = (e) => {
    //setSearch(e.target.value);
    bannerList(activePage, e.target.value);
    // console.log(e.target.value);
  };

  //***********Handel pagination*********** */
  const handlePageChange = (pageNo) => {
    setActivePage(pageNo);
    bannerList(pageNo);
  };

  var count = ((activePage - 1) * 10 + 1);

  return (
    <React.Fragment>
      <title>Banner Management</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />

              <button
                className="button py-auto"
                type="button"
                onClick={handelAddModalShow}
              >
                Add&nbsp;Banner
              </button>
            </div>
            <h4 className="Title">Banner Management</h4>
            {loader}
            <div className="TableList">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Banner Name</th>
                    <th>Image</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record &&
                    record.length > 0 &&
                    record.map((item, i) => (
                      <tr key={i}>
                        <td>{count++}</td>

                        <td>{item.clientName}</td>
                        <td>
                          {item.banner ? (
                            <img
                              src={item.banner}
                              height="50"
                              width="50"
                              alt={item.clientName}
                            ></img>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="status"
                              checked={item.status}
                              onChange={(e) => handleChecked(e, item._id)}
                            />
                            <label className="form-check-label"></label>
                          </div>
                        </td>
                        <td>
                          <span
                            className="Green inline-block"
                            onClick={(e) => handelEditModalShow(item)}
                          >
                            <i className="fa fa-edit"></i>
                          </span>

                          <span
                            className="Red inline-block"
                            onClick={(e) => handelDeleteShow(item._id)}
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="ModalBox">
        {/* Add modal */}
        <Modal
          show={AddModal}
          // style={{ opacity: 1 }}
          onHide={handelAddModalClose}
        >
          <Modal.Header closeButton onClick={handelAddModalClose}>
            <Modal.Title>Add New Banner</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form method="POST">
              <div className="form-group">
                <label>Banner Name </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Banner Name"
                  name="clientName"
                  value={inputField.clientName}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.clientName}
                </span>
              </div>
              <div className="form-group">
                <div className="upload_image">
                  <label htmlFor="banner-img">
                    <span>Banner Image</span>
                    <i className="fa fa-upload"></i>
                  </label>
                  <input
                    id="banner-img"
                    type="file"
                    className="form-control"
                    name="banner"
                    onChange={(e) => {
                      handelImageOnchange(e);
                    }}
                  />
                  <span style={{ color: "red" }} className="error">
                    {errorField.banner}
                  </span>
                </div>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button variant="secondary" onClick={handelAddModalClose}>
              Close
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelSubmit}
              ref={submitButtonElement}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
        {/* End add Modal */}

        {/* Edit modal */}
        <Modal
          show={EditModal}
          // style={{ opacity: 1 }}
          onHide={handelEditModalClose}
        >
          <Modal.Header closeButton onClick={handelEditModalClose}>
            <Modal.Title>Edit Banner</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form method="POST">
              <div className="form-group">
                <label>Banner Name </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Banner Name"
                  name="clientName"
                  value={inputField.clientName}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.clientName}
                </span>
              </div>
              <div className="form-group">
                <div className="upload_image">
                  <label htmlFor="bannerImg">
                    <span>Banner Image </span>
                    <i class="fa fa-upload"></i>
                  </label>
                  <input
                    id="bannerImg"
                    type="file"
                    className="form-control"
                    name="banner"
                    onChange={(e) => {
                      handelImageOnchange(e);
                    }}
                  />

                  {inputField.preview ? (
                    <img
                      src={inputField.preview}
                      height="40"
                      width="40"
                      alt={inputField.preview}
                    />
                  ) : (
                    <img
                      src={inputField.bannerUrl}
                      height="40"
                      width="40"
                      alt={inputField.bannerUrl}
                    />
                  )}
                </div>
                {/* <span style={{ color: "red" }} className="error">
                  {errorField.banner}
                </span> */}
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            {/* <button variant="secondary" onClick={handelEditModalClose}>
              Close
            </button> */}
            <button
              className="primary"
              variant="primary"
              onClick={handelEditSubmit}
              ref={submitButtonElement}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
        {/* End edit Modal */}

        {/* Start Delete Modal */}
        <Modal
          show={DeleteModal}
          //style={{ opacity: 1 }}
          onHide={handelDeleteClose}
        >
          <Modal.Header closeButton onClick={handelDeleteClose}>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to delete this banner?</Modal.Body>
          <Modal.Footer>
            <button
              className="primary"
              variant="secondary"
              onClick={handelDeleteClose}
            >
              No
            </button>
            <button
              className="secondary"
              variant="primary"
              onClick={handelDelete}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* End delete Modal */}

        {/* block or unblock model */}
        <Modal show={BlockModal} onHide={handelBlockClose}>
          <Modal.Header closeButton onClick={handelBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to change the status?</Modal.Body>
          <Modal.Footer>
            <button
              className="secondary"
              variant="secondary"
              onClick={handelBlockClose}
            >
              No
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelUpdateStatus}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* end block unblock modal */}
      </div>
    </React.Fragment>
  );
}
